import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';
import styled, { css } from 'styled-components';
import { colors } from 'styles/colors';
import { devices } from 'styles/devices';

export const ScrollNavigation = ({ scrollItems, sectionBeforeRef }) => {
   const [sticky, setSticky] = useState({});
   const navListRef = useRef(null);

   const handleScroll = () => {
      if (sectionBeforeRef?.current?.getBoundingClientRect().top <= 0) {
         setSticky({
            sticky: true,
            left: sectionBeforeRef?.current?.getBoundingClientRect().left,
            right: sectionBeforeRef?.current?.getBoundingClientRect().right
         });
      } else {
         setSticky({
            sticky: false,
            left: 0,
            right: 0
         });
      }
   };

   useEffect(() => {
      handleScroll();

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
   }, []);

   return (
      <NavList ref={navListRef} sticky={sticky}>
         {scrollItems
            .filter((item) => !!item)
            .map((item) => (
               <NavItem key={item.id}>
                  <StyledLink
                     to={item.id}
                     spy={true}
                     smooth={true}
                     offset={-40}
                     activeClass="active"
                  >
                     {item.label}
                  </StyledLink>
               </NavItem>
            ))}
      </NavList>
   );
};

ScrollNavigation.propTypes = {
   scrollItems: PropTypes.arrayOf(
      PropTypes.oneOfType([
         PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string
         }),
         PropTypes.bool
      ])
   ),
   sectionsWrapperRef: PropTypes.any,
   sectionBeforeRef: PropTypes.any,
   headerRef: PropTypes.any
};

const NavList = styled.ul`
   display: block;
   list-style: none;
   padding: 0;
   margin: 0 -7px;
   padding-top: 20px;

   ${({ sticky }) =>
      sticky.sticky &&
      css`
         top: 60px;
         left: ${sticky?.left};
         right: ${sticky?.right};
         position: fixed;
         z-index: 0;
         width: 100%;
         padding: 20px 0;
         background: white;
         margin: 0 0 0 -20px;
         padding: 10px 20px;

         ${devices.tabletL} {
            margin: 0 0 0 -60px;
            padding: 10px 60px;
         }

         ${devices.tabletXL} {
            top: 0;
            margin: 0 0 0 -80px;
            padding: 10px 80px;
         }

         ${devices.desktop} {
            margin: 0 0 0 -100px;
            padding: 10px 100px;
         }
      `}
`;

const NavItem = styled.li`
   display: inline-block;
   padding: 3px 7px;
   font-size: 14px;

   &:hover {
      color: ${colors.primary};
   }

   &:not(:last-of-type)::after {
      content: '';
      display: inline-block;
      width: 1px;
      height: 14px;
      margin-bottom: -3px;
      margin-left: 14px;
      background: ${colors.neutral30};
   }
`;

const StyledLink = styled(Link)`
   display: inline-block;
   color: ${colors.neutral60};
   cursor: pointer;

   &:hover {
      color: ${colors.neutral60};
      text-decoration: underline;
   }

   &.active {
      color: ${colors.primary};
   }
`;
